/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const ArticlePage = lazyLoad(
  () => import('./index'),
  module => module.ArticlePage,
);
